import React from 'react'
import {
  Modal, Typography
} from 'antd'

import { Button } from 'src/components/Button'
import { EnumUserType } from 'src/utils/types'

import './SalePriceInfoModal.scss'

const { Text } = Typography

interface SalePriceInfoModalProps {
  open: boolean
  onClose: () => void
  text: string
  width?: number
  title?: string
  userType?: EnumUserType
  onDisputeClick?: () => void
}

export default function SalePriceInfoModal({
  open,
  onClose,
  text,
  width,
  title,
  userType,
  onDisputeClick,
  ...rest
}: SalePriceInfoModalProps) {
  const handleClose = async () => {
    if (onClose) {
      onClose()
    }
  }

  const handleDispute = () => {
    if (onDisputeClick) {
      onDisputeClick()
    }
  }

  const isSecondary = userType === EnumUserType.Secondary

  return (
    <Modal
      className="info-modal"
      width={width}
      centered
      open={open}
      closable={false}
      footer={null}
      {...rest}
    >
      {
        title && (
          <Text className="info-modal__title">
            {title}
          </Text>
        )
      }
      <Text className="info-modal__text">
        {text}
      </Text>
      <div className="info-modal__buttons">
        {isSecondary && (
          <Button
            className="info-modal__dispute-btn"
            color="danger"
            size="small"
            onClick={handleDispute}
          >
            Dispute Sales Price Amount
          </Button>
        )}
        <Button
          className="info-modal__btn"
          color="primary"
          size="small"
          onClick={handleClose}
        >
          Dismiss
        </Button>
      </div>
    </Modal>
  )
}
